import * as React from 'react';
import { IParkReceiptProps } from './ParkReceipt.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import ParkReceiptForm from './ParkReceipt.form';
import { usePRContextSelector } from '../ProductReceipts.context';

const ParkReceipt = (props: IParkReceiptProps): JSX.Element => {
  const { open, values, isProcessing, onOk: onApply, onCancel } = props;

  const noteFieldRef = React.useRef<HTMLTextAreaElement>();

  const ProductReceiptContext = usePRContextSelector<'ProductReceiptContext'>((state) => state.ProductReceiptContext);

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Park receipt',
        disabled: isProcessing,
        iconName: 'ParkSaleIcon',
        listener: () => {
          onApply({ ...values });
        },
        isDefault: true
      },
      {
        iconName: 'Cancel',
        title: 'Cancel',
        listener: () => {
          onCancel();
        }
      }
    ];
  };

  const focusNoteField = () => {
    noteFieldRef?.current?.focus();
  };

  React.useEffect(
    () => {
      if (open && noteFieldRef.current) {
        focusNoteField();
      }
    },
    [open, noteFieldRef.current]
  );

  return (<FormViewModal
    open={open}
    loading={false}
    title={'Park Receipt Confirmation'}
    formProps={{
      style: {
        height: '450px',
        minWidth: '500px'
      },
      formSchema: ParkReceiptForm,
      initialValues: {
        ...(ProductReceiptContext ?? {})
      },
      valuesSchema: ProductReceiptContext ?? {},
      fieldExtensions: {
        Note: {
          fieldRef: (Ref) => noteFieldRef.current = Ref
        }
      }
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}
    onActionsTabOut={focusNoteField}
    onActionShiftTabOut={focusNoteField}
  />);
};

export default ParkReceipt;
